import { useRef } from "react";
import { Link, useNavigate } from "react-router-dom"

const SearchHome = () => {
   const navigate = useNavigate();
   const headerSearch = useRef<HTMLInputElement>(null)
   const handleHeaderSearch = () => {
      window.location.href = `/search?searchtext=${headerSearch.current?.value}`
}

const searchKeyDownButtonHandler = (
   event: React.KeyboardEvent<HTMLInputElement>
 ) => {
   if (event.key === "Enter") {
      window.location.href = `/search?searchtext=${headerSearch.current?.value}`
   }
 };

    return <div className="col-md-12 homesearch bgwide-off box stack-top">
    <div className="container">
       <div  className="col-md-12 search text-center">
          <div className="row">
             <div className="col-md-2">&nbsp;</div>
             <div className="col-md-12 col-lg-8">
                <h2 className="searchheader">Welcome to RAPS. What are you looking for?</h2>
                <input className="form-control" id="search" placeholder="Search" ref={headerSearch} type="text" onKeyDown={searchKeyDownButtonHandler} /> 
                <div role='button' className="btn btn-default"  onClick={() => handleHeaderSearch()} id="btnsearch">GO</div>
             </div>
             <div className="col-md-2 hide">&nbsp;</div>
             <div className="col-md-12 dashboard text-center">
                <h2><a href="/member-dashboard/">My RAPS »</a></h2>
             </div>
          </div>
       </div>
    </div>
  </div>
}

export default SearchHome;